
















































































































































import { fetchSolicitudBaja } from '../fetchSolicitudBaja';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class DatosGenerales extends ComponenteBaseStepper {
  @Prop({ default: [] }) motivos!: any[];
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  destinosPosibles: any = [];
  rules = {
    required: (value: any) => !!value || 'Required.',
  };
  validarDatos() {
    this.menu = false;
    if (
      this.formFields.tramo.value &&
      this.formFields.observacion.value != '' &&
      this.formFields.motivoTipo.value != '' &&
      this.dialog
    ) {
      this.$emit('valido', true);
    } else {
      this.$emit('valido', false);
    }
  }
  date = moment().format('YYYY-MM');
  menu = false;

  findFilterlist({ key }: { key: string }) {
    return this.motivos.filter(x => x[key] !== 't');
  }

  actualizarCantidades(equipos: number, perifericos: number, clientes: number) {
    this.formFields.cantidadEquipos.value = equipos;
    this.formFields.cantidadPerifericos.value = perifericos;
    this.formFields.cantidadClientes.value = clientes;
  }

  async crearSolicitud(): Promise<boolean> {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja(
      {
        numero: this.nuevoDato.numero,
        motivo: this.nuevoDato.motivo,
        observacion: this.nuevoDato.observacion,
        tramo: this.nuevoDato.tramo,
        cantidadClientes: this.nuevoDato.cantidadClientes,
        cantidadEquipos: this.nuevoDato.cantidadEquipos,
        cantidadPerifericos: this.nuevoDato.cantidadPerifericos,
        usuario: JSON.parse(window.localStorage.user).id,
      },
      'conecta_solicitud_baja_cliente/crear_solicitud'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return false;
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Hubo un error al crear el detalle de la solicitud',
          {
            timeout: 3000,
          }
        );
        return false;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return false;
      });
  }

  nuevoDato: any = {};
  crearDato() {
    this.nuevoDato = {
      numero: this.formFields.numero.value,
      motivo: this.formFields.motivoTipo.value,
      observacion: this.formFields.observacion.value.trim(),
      tramo: this.formFields.tramo.value,
      cantidadClientes: this.formFields.cantidadClientes.value,
      cantidadEquipos: this.formFields.cantidadEquipos.value,
      cantidadPerifericos: this.formFields.cantidadPerifericos.value,
      cantidadSimCards: this.formFields.cantidadSimCards.value,
    };

    return this.crearSolicitud();
    //return this.nuevoDato.numero;
  }
  async getNumero() {
    let self = this;
    this.loadingService.showLoading();
    return fetchSolicitudBaja({}, 'conecta_solicitud_baja_cliente/get_numero')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.ult_bajaclinumero;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async cargarNumero() {
    this.formFields.numero.value = await this.getNumero();
  }

  mounted() {
    this.cargarNumero();
  }

  formFields: {
    numero: any;
    motivoTipo: any;
    observacion: any;
    tramo: any;
    cantidadClientes: any;
    cantidadEquipos: any;
    cantidadPerifericos: any;
    estado: any;
    cantidadSimCards: any;
    cantidaEquiposConfirmados: any;
  } = {
    numero: {
      label: 'Número',
      value: '',
    },
    motivoTipo: {
      label: 'Motivo Tipo (Obligatorio)',
      value: '',
    },
    observacion: {
      label: 'Observación (Obligatorio)',
      value: '',
    },
    tramo: {
      label: 'Tramo (Obligatorio)',
      value: '',
      min: new Date().toISOString().slice(0, 10),
    },
    cantidadClientes: {
      label: 'Cantidad Clientes',
      value: 0,
    },
    cantidadEquipos: {
      label: 'Cantidad Equipos',
      value: 0,
    },
    cantidadPerifericos: {
      label: 'Cantidad Periféricos',
      value: 0,
    },
    estado: {
      label: 'Estado',
      value: 'Solicitado',
    },
    cantidadSimCards: {
      label: 'Cantidad Sim Cards',
      value: 0,
    },
    cantidaEquiposConfirmados: {
      label: 'Cantida Equipos Confirmados',
      value: 0,
    },
  };

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dictionaryFormErrors: any = {};
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
